import React, { useEffect, useState, useRef } from 'react';
import { InputItem, Picker, List, Modal, Toast } from 'antd-mobile';
import ModalContent from '../component/modal/modal';
import TitleComponent from '../component/title/title';
import ImagePicker from '../../component/image-picker/index';
import { ApiCore } from '../../api';
import styles from './doctorComplete.module.scss';
import OSS from "ali-oss";
import { Button } from 'antd-mobile-v5';
import utils from '../../utils/utils';

const api = new ApiCore();
let photoList: any = [];

const jobTitleData = [{
    "label":"住院医师",
    "value":"住院医师",
}, {
    "label":"主治医师",
    "value":"主治医师"
}, {
    "label":"副主任医师",
    "value":"副主任医师"
}, {
    "label":"主任医师",
    "value":"主任医师"
}];

function DoctorComplete(props: any) {

    // 科室
    const [officeName, setOfficeName] = useState<any>('');
    // 职称
    const [positionName, setPositionName] = useState<any>([]);
    // 真实姓名
    const [realName, setRealName] = useState<any>('');
    // 证件照上传备注
    const [uploadNote, setUploadNote] = useState<any>('');
    // 查看示例模态框
    const [modalVisible, setModalVisible] = useState<any>(false);
    //图片
    const [photos, setPhotos] = useState<any>([]);
    // 获取OSS访问令牌
    const [ossData, setOssData] = useState<any>({});
    // 证件照上传示例 
    const [uploadExample, setUploadExample] = useState<any>('');
    // 职称数据 
    const [titleList, setTitleList] = useState<any>(jobTitleData);
    // 系统返回
    const mPhotoRef = useRef<any>(null);
    // 机构
    const [institution, setInstitution] = useState(null);

    useEffect(() => {
        //设置网页title
        document.title = '完善信息';
        getOssData()
        return () => {
        }
    }, [])

    // 机构
    const onInstitution = (value: any) => {
        setInstitution(value)
    }
    // 科室
    const onOfficeName = (value: any) => {
        setOfficeName(value)
    }
    // 职称
    const onPositionName = (value: any) => {
        setPositionName(value)
    }

    // 真实姓名
    const onRealName = (value: any) => {
        setRealName(value)
    }

    // 查看拍照示例
    const viewSampleGraph = () => {
        setModalVisible(true)
    }

    // 关闭模态框
    const onModalClose = () => {
        setModalVisible(false)
    }

    //当图片选择改变时
    const onPhotoChange = (files: any) => {
        setPhotos(files)
    }

    /**
     * 提取上传类型
     * @param {*} json 
     * @returns 
     */
    const filterPathPre = (json: any, type?: any) => {
        let newJson = json;
        let data: any = [];
        data = newJson.pathPre.split(',')
        data.map((i: any) => {
            if (i.includes(type)) {
                newJson.pathPre = i
            }
        })

        return newJson
    }

    /**
     * 获取OSS访问令牌
     */
    const getOssData = () => {
        api.GetCaseSts().then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setOssData(res.data)
            }
        })
    };

    /**
     * 上传
     * @param item 
     * @returns 
     */
    const onUpload = (item: any): Promise<object | undefined> => {
        let client = new OSS({ ...filterPathPre(ossData, 'image') });
        return new Promise((resolve, reject) => {
            const file = item.file;
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const suffix = file.name.slice(file.name.lastIndexOf('.'));
                let time = new Date().getTime();
                const path = `${ossData.pathPre}doctorComplete/${time}${suffix}`;
                // oss上传
                client.put(
                    path,
                    file,
                ).then((res: any) => {
                    let url = res.url;
                    resolve({ url: url });
                    photoList.push(
                        {
                            url: url
                        }
                    )
                    setPhotos(photoList)
                })
                    .catch((err: any) => {
                        Toast.fail('上传失败，请重新上传！', 1)
                        setPhotos(photos)
                    })
            }
        });
    };

    // 当图片删除
    const onPhotoDelete = (fileList: any) => {
        setPhotos(fileList)
    }

    // 数据 
    const dataList = [
        { key: 'InputItem', label: '姓名', type: 'text', placeholder: '请填写您的真实姓名', maxLength: 50, value: realName, onChange: (v: any) => onRealName(v), required: true },
        { key: 'InputItem', label: '请输入您所在医疗机构', type: 'text', placeholder: '请输入医疗机构的名称', maxLength: 50, value: institution, onChange: (v: any) => onInstitution(v), required: true },
        { key: 'InputItem', label: '请输入您所在的科室', type: 'text', placeholder: '请填写您所在的科室', maxLength: 50, value: officeName, onChange: (v: any) => onOfficeName(v), required: true },
        { key: 'Picker-title', label: '请选择您的职称', type: 'text', placeholder: '请选择您的职称', maxLength: 50, value: positionName, onChange: (v: any) => onPositionName(v), required: false }
    ]

    const submitData = () => {
        if (!realName) {
            Toast.info('请输入您的真实姓名', 0.8);
            return;
        }
        if (!institution) {
            Toast.info('请输入医疗机构的名称', 0.8);
            return;
        }
        if (!officeName) {
            Toast.info('请输入您所在科室名称', 0.8);
            return;
        }
        let photosList: any = []
        if (photos && photos.length > 0) {
            photos.forEach((p: any) => {
                photosList.push(p.url)
            })
        }
        if (photosList.length === 0) {
            Toast.info('请上传医生执业资格证', 0.8);
            return;
        }
        const _param: any = {
            name: realName, // 姓名
            institution: institution,  // 机构
            dept: officeName, // 科室
            // certificateUrl: photosList.length > 0 ? photosList.join(',') : '' // 证书
            certificate: photosList.length > 0 ? photosList.join(',') : '' // 证书
        };
        //职称
        if (positionName && positionName[0]) {
            _param.title = positionName[0];
        }
        const urlParams = utils.getUrlParams() || {};
        const groupCode = urlParams.groupCode || '';
        if (groupCode) {
            _param.groupCode= groupCode;
        }
        // api.toDoctorPerfectInfo(_param).then((res: any) => {
        api.toVisitRegisterAdd(_param).then((res: any) => {
            if (res.code == 0) {
                Toast.info('保存成功');
                if (res.data?.state == 2) {
                    props.history.push('/doctor/home');
                } else {
                    props.history.push('/pfizer/auditComplete');
                }
            } else {
                Toast.info(res.message || '保存失败');
            }
        });
    }

    const toNavigateBack = () => {
        if (utils.isMiniProgram()) {
            (window as any).wx.miniProgram.navigateBack({
              delta: 1,
              success: function (e: any) {
              },
              fail: function (e: any) {
              }
            })
          } 
    }

    return (
        <div className={styles.doctorComplete}>
            <div className={styles.doctor_info}>
                <TitleComponent title={'完善您的医生信息'} subTitle={'请您先补充下列信息，<br />补充完成后才能使用完整的功能'} />
                {
                    dataList.map((item: any, index: any) => (
                        <div className={`${styles.InputItemContent} ${styles.provinceWrap} ${item.required ? styles.required : ''}`} key={index}>
                            <label className={styles.label}>
                                {
                                    item.isHidden && (item.key == 'Picker-city' || item.key == 'Picker-province')  ? '' : item.label
                                }
                            </label>

                            {item.key == 'InputItem' &&
                                <InputItem
                                    type={item.type}
                                    placeholder={item.placeholder}
                                    maxLength={item.maxLength}
                                    value={item.value}
                                    onChange={item.onChange}
                                />}


                            {/* 职称下拉 */}
                            {item.key == 'Picker-title' &&
                                <Picker
                                    data={titleList}
                                    cols={1}
                                    className="forss"
                                    value={positionName}
                                    onChange={(v: any) => onPositionName(v)}
                                >
                                    <List.Item
                                        arrow={'horizontal'}
                                        extra={item.placeholder}
                                    ></List.Item>
                                </Picker>
                            }
                        </div>

                    ))
                }

                <div className={`${styles.InputItemContent}`}>
                    <div className={`${styles.uploadContent} ${styles.required}`}>
                        <label className={`${styles.findlabel}`}>医生执业资格证</label>
                        <div className={styles.view} onClick={viewSampleGraph}><span className={styles.icon}>?</span>查看拍照示例</div>
                    </div>
                    <div className={styles.hint} dangerouslySetInnerHTML={{ __html: uploadNote || '请上传需要正面打开盖有两个章的那页，及本人信息的那页，保证照片内容清晰可辨认' }}></div>

                    {/* 拍照示例 */}
                    <Modal
                        visible={modalVisible}
                        transparent
                        maskClosable={false}
                        onClose={onModalClose}
                        title="拍照示例"
                        footer={[
                            {
                                text: '关闭',
                                onPress: () => {
                                    setModalVisible(false)
                                }
                            }
                        ]}
                    >
                        <ModalContent data={uploadExample} />
                    </Modal>

                    <ImagePicker
                        ref={mPhotoRef}
                        filesList={photos}
                        onChange={onPhotoChange}
                        multiple={false}
                        max={100}
                        mode="cover"
                        onUpload={onUpload}
                        width="22%"
                        onFail={() => { Toast.fail('上传失败！', 1) }}
                        config={['defaultDashed']}
                        disabled={false}
                        onDelete={onPhotoDelete}
                    />
                </div>

            </div>

            <div className={styles.btn}>
                <Button
                    onClick={submitData}
                    color='primary'
                >
                    完成
                </Button>
            </div>

            <div className={styles.btn}>
                <Button
                    onClick={toNavigateBack}
                    color='primary'
                    fill='outline'
                >
                    返回
                </Button>
            </div>

        </div>
    )

}

export default DoctorComplete;